<template>
    <div class="pages">
        <!-- 快捷栏 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <div class="box">
            <div class="boxBreadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/user-center/0/my-order2' }">{{ $t('我的订单') }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ $t('订单详情') }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="boxDetail" :class="{ 'is-h5': isH5 }">

                <div class="h5-status-card" v-if="isH5 && items.length">
                    <div class="h5-status-title">{{ orderStatusText(order_status) }}</div>
                    <div class="h5-status-desc" v-if="order_status == 0">
                        {{ $t('商品已拍下，等待买家付款，超时订单自动关闭') }}
                    </div>
                </div>

                <div class="boxDetail-message virtual-goods-message" v-if="items[0] && items[0].product_type == 1">
                    <div class="flex-direction align-center" style="width: 100%;">
                        <div class="margin-bottom-16 text-24 text-weight text-333">{{ $t('虚拟商品') }}</div>
                        <div class="margin-bottom-16 text-16">{{ $t('虚拟商品商家无需发货') }}</div>
                    </div>

                    <div class="flex-direction align-center" v-if="order_status != 6" style="width: 100%;">
                        <div class="align-center" v-if="virtual_goods == 0">
                            <div class="message-btn2 message-btn" style="" @click="onAfterSale()">
                                {{ $t('申请售后') }}
                            </div>
                            <div class="message-btn1 message-btn" v-if="canDownloadVirtualGoods()"
                                @click="onDownload()">{{ $t('下载') }}</div>
                        </div>
                    </div>
                </div>

                <div class="logistics" v-if="items[0] && items[0].product_type == 1">

                    <div class="logistics-order">
                        <div class="order-tit">{{ $t('订单信息') }}</div>
                        <div class="order-txt">
                            <span class="txt-left">{{ $t('收货地址') }}</span>
                            <span>
                                {{ address.province_name }} {{ address.city_name }} {{ address.district_name }}
                                {{ address.address }} {{ address.consignee }} {{ address.mobile }}
                            </span>
                        </div>
                        <div class="order-txt">
                            <span class="txt-left">{{ $t('订单编号') }}</span>
                            <span>{{ detail.order_sn }}</span>
                        </div>
                        <div class="order-txt">
                            <span class="txt-left">{{ $t('创建时间') }}</span>
                            <span>{{ detail.create_time }}</span>
                        </div>
                        <div v-if="items[0] && items[0].product_type != 1">
                            <div class="order-txt" v-if="order_status >= 1">
                                <span class="txt-left">{{ $t('付款时间') }}</span>
                                <span>{{ detail.pay_time_text }}</span>
                            </div>
                            <div class="order-txt" v-if="order_status >= 2">
                                <span class="txt-left">{{ $t('发货时间') }}</span>
                                <span>{{ detail.send_time_text }}</span>
                            </div>
                            <div class="order-txt" v-if="order_status >= 4">
                                <span class="txt-left">{{ $t('收货时间') }}</span>
                                <span>{{ detail.receipt_time_text }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pc-goods-table-wrap" v-if="!isH5">
                    <el-table :data="items" style="width: 100%;border-radius: 8px;">
                        <el-table-column :label="$t('商品')" width="458">
                            <template slot-scope="scope">
                                <div class="commodity pointer" @click="gotoDetail(scope.row)">
                                    <img :src="scope.row.product_image" alt="">
                                    <div class="commodity-r">
                                        <div class="commodity-tit">{{ scope.row.product_title }}</div>
                                        <div class="commodity-txt">{{ scope.row.product_sku_text }}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('单价')" width="200">
                            <template slot-scope="scope">
                                <div class="unitPrice">
                                    <div class="unitPrice-t">￥{{ scope.row.product_price }}</div>
                                    <!-- <div class="unitPrice-b">￥1200.00</div> -->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('数量')" width="120">
                            <template slot-scope="scope">
                                <div class="text-14">
                                    X{{ scope.row.product_num }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('实付款')" width="200">
                            <template slot-scope="scope">
                                <div class="text-14">
                                    ￥{{ scope.row.pay_price }}
                                </div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column :label="$t('状态')" width="200">
                        <template slot-scope="scope">
                            <div class="text-14" v-if="scope.row.product_type != 1">
                                <div v-if="order_status == 0">
                                    <div style="text-align: center;margin-bottom: 10px;">{{ $t('未付款') }}</div>
                                    <el-statistic :format="$t('mm分钟ss秒')" :value="deadline5"
                                        time-indices></el-statistic>
                                </div>
                            </div>
                            <div class="text-14" v-else>
                                <div style="text-align: center;margin-bottom: 10px;">{{ $t('已完成') }}</div>
                            </div>
                        </template>
                    </el-table-column> -->
                    </el-table>
                </div>

                <div class="h5-goods-list" v-if="isH5">
                    <div class="h5-section-title">{{ $t('商品信息') }}</div>
                    <div class="h5-goods-card" v-for="(item, index) in items" :key="index">
                        <div class="commodity pointer" @click="gotoDetail(item)">
                            <img :src="item.product_image" alt="">
                            <div class="commodity-r">
                                <div class="commodity-tit line2">{{ item.product_title }}</div>
                                <div class="commodity-txt line2">{{ item.product_sku_text }}</div>
                            </div>
                        </div>
                        <div class="h5-goods-row">
                            <span>{{ $t('单价') }}</span>
                            <span>￥{{ item.product_price }}</span>
                        </div>
                        <div class="h5-goods-row">
                            <span>{{ $t('数量') }}</span>
                            <span>x{{ item.product_num }}</span>
                        </div>
                        <div class="h5-goods-row h5-goods-row-pay">
                            <span>{{ $t('实付款') }}</span>
                            <span class="h5-goods-pay">￥{{ item.pay_price }}</span>
                        </div>
                    </div>
                </div>

                <div class="sum" :class="{ 'h5-sum-card': isH5 }">
                    <div class="sum-box margin-bottom-8">
                        <span>{{ $t('商品总价') }}</span>
                        <span>￥{{ detail.goods_amount }}</span>
                    </div>
                    <div class="sum-box margin-bottom-8">
                        <span>{{ $t('运费') }}</span>
                        <span>￥{{ detail.dispatch_amount }}</span>
                    </div>
                    <div class="sum-box">
                        <span>{{ $t('实付款') }}</span>
                        <span class="text-85674B text-20">￥{{ detail.pay_fee }}</span>
                    </div>
                </div>

                <div class="logistics" v-if="items[0] && items[0].product_type != 1">
                    <!-- order_status -->

                    <!-- <div class="" v-if="order_status == 2 || order_status == 3 || order_status == 4">
                        <div class="logistics-tit">{{ $t('物流信息') }}</div>
                        <logistics :list="expressage_list" :indexValue="expressageValue"></logistics>
                    </div> -->

                    <div class="logistics-order">
                        <div class="order-tit">{{ $t('订单信息') }}</div>
                        <div class="order-txt">
                            <span class="txt-left">{{ $t('收货地址') }}</span>
                            <span>
                                {{ address.province_name }} {{ address.city_name }} {{ address.district_name }}
                                {{ address.address }} {{ address.consignee }} {{ address.mobile }}
                            </span>
                        </div>
                        <div class="order-txt">
                            <span class="txt-left">{{ $t('订单编号') }}</span>
                            <span>{{ detail.order_sn }}</span>
                        </div>
                        <div class="order-txt">
                            <span class="txt-left">{{ $t('创建时间') }}</span>
                            <span>{{ detail.create_time }}</span>
                        </div>
                        <div v-if="items[0] && items[0].product_type != 1">
                            <div class="order-txt" v-if="order_status >= 1">
                                <span class="txt-left">{{ $t('付款时间') }}</span>
                                <span>{{ detail.pay_time_text }}</span>
                            </div>
                            <div class="order-txt" v-if="order_status >= 2">
                                <span class="txt-left">{{ $t('发货时间') }}</span>
                                <span>{{ detail.send_time_text }}</span>
                            </div>
                            <div class="order-txt" v-if="order_status >= 4">
                                <span class="txt-left">{{ $t('收货时间') }}</span>
                                <span>{{ detail.receipt_time_text }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="items[0] && items[0].product_type != 1" class="order-step-wrap">
                    <ShoppingProcess :list="stepList" :indexValue="indexValue"
                        v-if="order_status != -2 && order_status != -1" />
                </div>

                <div class="boxDetail-message pc-message" v-if="items[0] && items[0].product_type != 1">
                    <div v-if="order_status == 0" class="flex-direction align-center" style="width: 100%;">
                        <div class="margin-bottom-16 text-16 align-center">
                            {{ $t('订单状态：商品已拍下，等待买家付款，您还有') }}
                            <el-statistic format="HH时mm分钟ss秒" :value="deadline5" time-indices
                                style="width: 130px;"></el-statistic>
                            {{ $t('来付款，超时订单自动关闭') }}
                        </div>
                        <div class="message-btn1 message-btn" @click="onGoPay">{{ $t('立即付款') }}</div>
                    </div>
                    <div v-if="order_status == 1" class="flex-direction align-center" style="width: 100%;">
                        <div class="margin-bottom-16 text-16">{{ $t('订单状态：买家已付款，待商家发货') }}</div>
                        <div class="message-btn1 message-btn" @click="onUrgeDelivery">{{ $t('提醒发货') }}</div>
                    </div>
                    <div v-if="order_status == 2" class="flex-direction align-center" style="width: 100%;">
                        <div class="margin-bottom-16 text-16">{{ $t('订单状态：卖家已发货，待买家收货') }}</div>
                        <div class="align-center">
                            <div class="message-btn2 message-btn" @click="onAfterSale()">{{ $t('申请售后') }}</div>
                            <div class="message-btn2 message-btn" v-if="getExpressId()" @click="onViewLogistics">
                                {{ logisticsLoading ? $t('加载中') : $t('查看物流') }}
                            </div>
                            <div class="message-btn1 message-btn" @click="show = true">{{ $t('确认收货') }}</div>
                        </div>
                    </div>
                    <div v-if="order_status == 3" class="flex-direction align-center" style="width: 100%;">
                        <div class="margin-bottom-16 text-16">{{ $t('订单状态：当前交易已完成') }}</div>
                        <div class="message-btn1 message-btn" @click="onEvaluate">{{ $t('评价') }}</div>
                    </div>
                    <div v-if="false" class="flex-direction align-center" style="width: 100%;">
                        <div class="margin-bottom-16 text-24 text-weight text-333">{{ $t('交易成功') }}</div>
                        <div class="margin-bottom-16 text-16">{{ $t('订单状态：当前交易已完成') }}</div>
                        <div class="message-btn1 message-btn" v-if="flase">{{ $t('下载') }}</div>
                    </div>
                    <div v-if="order_status == -2 || order_status == -1" class="flex-direction align-center"
                        style="width: 100%;">
                        <div class="margin-bottom-16 text-24 text-weight text-333">{{ $t('交易失败') }}</div>
                        <div class="margin-bottom-16 text-16">{{ $t('订单状态：当前交易已关闭') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="h5-action-bar" v-if="isH5 && items[0] && items[0].product_type != 1">
            <template v-if="order_status == 0">
                <div class="h5-countdown" v-if="order_status == 0">
                    <div class="h5-countdown-label">{{ $t('剩余付款时间') }}</div>
                    <div class="h5-countdown-time">
                        <el-statistic format="HH时mm分钟ss秒" :value="deadline5" time-indices></el-statistic>
                    </div>
                </div>
                <div class="message-btn1 message-btn" @click="onGoPay">{{ $t('立即付款') }}</div>
            </template>
            <template v-else-if="order_status == 1">
                <div class="message-btn1 message-btn" @click="onUrgeDelivery">{{ $t('提醒发货') }}</div>
            </template>
            <template v-else-if="order_status == 2">
                <div class="message-btn2 message-btn" @click="onAfterSale()">{{ $t('申请售后') }}</div>
                <div class="message-btn2 message-btn" v-if="getExpressId()" @click="onViewLogistics">
                    {{ logisticsLoading ? $t('加载中') : $t('查看物流') }}
                </div>
                <div class="message-btn1 message-btn" @click="show = true">{{ $t('确认收货') }}</div>
            </template>
            <template v-else-if="order_status == 3">
                <div class="message-btn1 message-btn" @click="onEvaluate">{{ $t('评价') }}</div>
            </template>
        </div>

        <transition name="detail-pop">
            <div class="modal" v-if="show">
                <div class="modal-box">
                    <div class="modal-box-tit">{{ $t('提示') }}</div>
                    <div class="modal-box-txt">{{ $t('请收到货后，再确认收货，您确定收货吗？') }}</div>
                    <div class="modal-box-btn">
                        <div class="btn-l" @click="show = false">{{ $t('取消') }}</div>
                        <div class="btn-r" @click="onConfirm">{{ $t('确定') }}</div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="detail-pop">
            <div class="modal logistics-modal" v-if="logisticsShow" @click.self="logisticsShow = false">
                <div class="modal-box">
                    <div class="modal-box-tit">{{ $t('物流信息') }}</div>
                    <div class="logistics-summary">
                        <div v-if="logisticsData.Name">{{ $t('快递公司') }}：{{ logisticsData.Name }}</div>
                        <div v-if="logisticsData.LogisticCode">{{ $t('快递单号') }}：{{ logisticsData.LogisticCode }}</div>
                    </div>
                    <div class="logistics-traces">
                        <div class="logistics-trace" v-for="(trace, index) in logisticsData.Traces" :key="index">
                            <div class="logistics-trace-time">{{ trace.AcceptTime }}</div>
                            <div class="logistics-trace-content">{{ trace.AcceptStation }}</div>
                        </div>
                    </div>
                    <div class="modal-box-btn">
                        <div class="btn-r" @click="logisticsShow = false">{{ $t('确定') }}</div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 左侧悬浮框 -->
        <div class="pc-float">
            <leftSuspension />
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<style scoped>
    div /deep/ .el-statistic .con .number {
        font-size: 16px;
    }
</style>

<script>
    import ShortcutBar from '@/components/ShortcutBar'
    import ShoppingProcess from './components/ShoppingProcess.vue';
    import logistics from './components/logistics.vue';
    import leftSuspension from "@/components/leftSuspension.vue";
    import { orderDetail, notarizeDelivery, downloadLink, getconf, getLogistics } from '@/api/user';
    import footerBar from '@/components/footerBar';

    export default {
        name: 'UserCenter',
        components: {
            'footer-bar': footerBar,
            'shortcut-bar': ShortcutBar,
            ShoppingProcess,
            logistics,
            leftSuspension,
        },
        data() {
            return {
                stepList: [{
                    txt: this.$t('拍下商品'),
                    value: '1'
                }, {
                    txt: this.$t('付款'),
                    value: '2'
                }, {
                    txt: this.$t('卖家发货'),
                    value: '3'
                }, {
                    txt: this.$t('确认收货'),
                    value: '4'
                }, {
                    txt: this.$t('评价'),
                    value: '5'
                }],//步骤条
                indexValue: '0',//步骤条位置
                tableData: [],//商品列表
                expressage_list: [],//快递列表
                expressageValue: '2',//快递位置索引
                show: false,//模态框提示
                product_id: '',//订单ID
                items: [],//商品列表
                order_status: '',//订单状态
                deadline5: new Date("2025-04-10 11:34:00"),//倒计时
                detail: {},//订单详情
                address: {},//地址信息
                is_close: true,//是否为取消交易

                virtual_goods: '',//是否允许虚拟产品退款
                isH5: typeof window !== 'undefined' && window.innerWidth < 768,
                logisticsShow: false,//物流弹窗显示状态
                logisticsLoading: false,//物流查询加载状态
                logisticsData: {},//物流查询结果
            }
        },
        mounted() {
            this.updateIsH5();
            window.addEventListener('resize', this.updateIsH5);
            let product_id = this.$route.params.id;
            this.product_id = product_id
            this.onOrderDetail(product_id);
            this.onGetconf()
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateIsH5);
        },
        methods: {
            updateIsH5() {
                this.isH5 = window.innerWidth < 768;
            },
            orderStatusText(status) {
                const map = {
                    '0': this.$t('等待买家付款'),
                    '1': this.$t('等卖家发货'),
                    '2': this.$t('待买家收货'),
                    '3': this.$t('买家已收货'),
                    '4': this.$t('订单已完成'),
                    '-1': this.$t('订单关闭'),
                    '-2': this.$t('订单关闭'),
                };
                return map[String(status)] || this.$t('订单详情');
            },
            /**获取配置 */
            onGetconf() {
                getconf({ module: 'system' }).then(res => {
                    this.virtual_goods = res.data.virtual_goods
                })
            },
            /**去申请售后 */
            onAfterSale() {
                // console.log(this.items);
                // return
                this.$router.push({ name: 'RefundOption', params: { order: encodeURIComponent(JSON.stringify(this.items[0])) } });

            },
            /**下载 */
            onDownload() {
                if (!this.canDownloadVirtualGoods()) {
                    return
                }
                let data = {
                    order_sn: this.detail.order_sn,
                    product_sku_id: this.items[0].product_sku_price_id
                }
                downloadLink(data).then(res => {
                    if (res.code == 1) {
                        window.open(res.data.url);
                        this.$message.success(this.$t('下载成功'));
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
            },
            /**是否允许下载虚拟商品：所有商品未申请售后或售后被拒绝，且未超过下载期限时才允许下载 */
            canDownloadVirtualGoods() {
                return Array.isArray(this.items) && this.items.length > 0
                    && this.items.every(item => (item.refund_status == 0 || item.refund_status == -1)
                        && !this.isVirtualGoodsDownloadExpired(this.detail.pay_time, item.time_day))
            },
            /**
             * 判断虚拟商品下载期限是否已过：time_day 为空时不限制下载。
             * @param {number|string} payTime 支付时间戳（兼容秒级、毫秒级时间戳）
             * @param {number|string} timeDay 商品可下载天数
             * @returns {boolean} 是否已超过下载期限
             */
            isVirtualGoodsDownloadExpired(payTime, timeDay) {
                if (timeDay === '' || timeDay === null || timeDay === undefined) {
                    return false
                }
                const downloadDays = Number(timeDay)
                const paymentTimestamp = Number(payTime)
                if (!Number.isFinite(downloadDays) || !Number.isFinite(paymentTimestamp)) {
                    return false
                }
                const paymentTimeMs = paymentTimestamp < 100000000000 ? paymentTimestamp * 1000 : paymentTimestamp
                const paidDays = Math.floor((Date.now() - paymentTimeMs) / (24 * 60 * 60 * 1000))
                return paidDays > downloadDays
            },
            /**催发货 */
            onUrgeDelivery() {
                this.$message.success(this.$t('催发货成功，商家已收到提示'));
            },
            /**获取首个商品的物流记录ID，用于物流查询 */
            getExpressId() {
                const firstItem = this.items[0]
                return firstItem && firstItem.express ? firstItem.express.id : ''
            },
            /**查看物流 */
            onViewLogistics() {
                const expressId = this.getExpressId()
                if (!expressId || this.logisticsLoading) {
                    return
                }
                this.logisticsLoading = true
                getLogistics({ order_id: this.product_id, express_id: expressId, is_force: 0 }).then(res => {
                    if (res.code == 1) {
                        this.logisticsData = res.data || {}
                        this.logisticsShow = true
                    } else {
                        this.$message.warning(res.msg)
                    }
                }).catch(() => {
                    this.$message.warning(this.$t('物流信息获取失败'))
                }).finally(() => {
                    this.logisticsLoading = false
                })
            },
            /**去支付 */
            onGoPay() {
                this.$router.push({ name: "placeOrder", params: { order: encodeURIComponent(JSON.stringify(this.detail)) } });
            },
            /**商品详情 */
            gotoDetail(e) {
                // console.log(e);
                this.$router.push({ name: 'ProductDetails', params: { id: e.product_id } })
            },
            /**订单详情 */
            onOrderDetail(id) {
                orderDetail({ id: id }).then(res => {
                    let data = res.data
                    this.items = data.items
                    this.order_status = data.status
                    this.detail = data
                    this.address = data.address

                    if (this.order_status != 5 && this.order_status != 6) {
                        this.indexValue = this.order_status
                    }
                    // if (this.order_status == -2 && this.order_status == -1) {
                    //     this.is_close = false
                    // } else {
                    //     this.is_close = true
                    //     if (this.order_status != 5 && this.order_status != 6) {
                    //         this.indexValue = this.order_status
                    //     }
                    // }
                    console.log(data);
                })
            },
            /**评价 */
            onEvaluate() {
                this.$router.push({ name: 'Evaluate', params: { id: this.product_id } });
            },
            /**确定收货 */
            onConfirm() {
                notarizeDelivery({ id: this.product_id }).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg);
                    } else {
                        this.$message.warning(res.msg);
                    }
                    this.onOrderDetail(this.product_id);
                    this.show = false
                })
            }
        },
    };
</script>

<style scoped lang="scss">
    @mixin pc-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: #333333 #ececec;

        &::-webkit-scrollbar {
            height: 6px;
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #ececec;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #333333;
            border-radius: 4px;

            &:hover {
                background: #000000;
            }
        }
    }

    .page-header {
        z-index: 999;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
    }

    .page-header-placeholder {
        height: 56px;
    }

    .h5-goods-list {
        display: none;
    }

    .box {
        padding: 0 var(--page-gutter-wide) 80px;
    }

    /*面包屑*/
    .boxBreadcrumb {
        padding: 26px 0 32px 0;
    }

    .download {
        background: #000000;
        padding: 4px 12px;
        color: #FFFFFF;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }

    /*内容 */
    .boxDetail {
        /* // padding: 32px; */
        box-sizing: border-box;
        background-color: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
        padding: 32px 24px;
        overflow: visible;

        /**内容信息 */
        .boxDetail-message {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 40px 0 0;
            /* // border-bottom: 1px solid #CCCCCC; */

            &.virtual-goods-message {
                flex-direction: column;
                padding-bottom: 32px;
            }

            .message-btn {
                width: 160px;
                height: 40px;
                border-radius: 4px;
                font-size: 14px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                box-sizing: border-box;
            }

            .message-btn1 {
                background: #000000;
                color: #FFFFFF;
            }

            .message-btn2 {
                border: 1px solid #CCCCCC;
                background: #FFFFFF;
                margin-right: 24px;
            }
        }

        /**商品信息 */
        .commodity {
            display: flex;

            img {
                width: 120px;
                height: 120px;
                border-radius: 8px;
                object-fit: cover;
                object-position: center;
                flex-shrink: 0;
            }

            .commodity-r {
                margin-left: 16px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .commodity-tit {
                    font-size: 14px;
                    color: #333333;
                }

                .commodity-txt {
                    font-size: 14px;
                    color: #999999;
                }
            }
        }

        .unitPrice {
            font-size: 14px;

            .unitPrice-t {
                color: #333333;
                margin-bottom: 8px;
            }

            .unitPrice-b {
                color: #999999;
                text-decoration-line: line-through;
            }
        }
    }

    /**商品金额 */
    .sum {
        padding-top: 24px;
        font-size: 14px;

        .sum-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    .width-100 {
        width: 100px;
        text-align: right;
    }

    .order-step-wrap {
        margin-top: 32px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 4px;
        @include pc-scrollbar;
    }

    .pc-goods-table-wrap {
        overflow-x: auto;
        padding-bottom: 4px;
        @include pc-scrollbar;

        /* /deep/ .el-table {
            min-width: 1178px;
        } */

        /deep/ .el-table__body-wrapper {
            @include pc-scrollbar;
        }
    }

    /**物流信息 */
    .logistics {
        margin-top: 32px;
        padding: 32px 0 32px;
        border-bottom: 1px solid #CCCCCC;
        border-top: 1px solid #CCCCCC;

        .logistics-tit {
            padding-bottom: 16px;
            font-size: 16px;
            font-weight: 600;
        }

        .logistics-order {
            .order-tit {
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 16px;
            }

            .order-txt {
                margin-bottom: 8px;
                font-size: 14px;

                .txt-left {
                    padding-right: 30px;
                    color: #999999;
                }
            }

            .order-txt:last-child {
                margin-bottom: 0;
            }

        }
    }

    /**模态框 */
    .modal {
        width: 100vw;
        height: 100vh;
        /* background-color: rgba($color: #000000, $alpha: 0.5); */
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;

        .modal-box {
            padding: 40px 45px;
            background-color: #FFFFFF;
            border-radius: 16px;
            text-align: center;

            .modal-box-tit {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }

            .modal-box-txt {
                font-size: 16px;
                margin: 24px 0 40px;
            }

            .modal-box-btn {
                display: flex;

                div {
                    width: 180px;
                    height: 40px;
                    border-radius: 8px;
                    line-height: 40px;
                    cursor: pointer;
                }

                .btn-l {
                    border: 1px solid #999999;
                    background: #FFFFFF;
                    color: #333333;
                }

                .btn-r {
                    background: #000000;
                    color: #FFFFFF;
                    margin-left: 40px;
                }
            }
        }
    }

    .logistics-modal {
        .modal-box {
            width: 640px;
            max-height: calc(100vh - 80px);
            text-align: left;
            box-sizing: border-box;
        }

        .modal-box-tit {
            text-align: center;
        }

        .logistics-summary {
            margin: 24px 0 16px;
            padding: 12px 16px;
            border-radius: 4px;
            background: #f8f8f8;
            color: #333333;
            font-size: 14px;
            line-height: 1.8;
        }

        .logistics-traces {
            max-height: 400px;
            overflow-y: auto;
            padding-left: 16px;
        }

        .logistics-trace {
            position: relative;
            padding: 0 0 18px 20px;
            border-left: 1px solid #e5e5e5;

            &::before {
                position: absolute;
                top: 4px;
                left: -5px;
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: #999999;
                content: '';
            }

            &:first-child::before {
                background: #61AC85;
            }
        }

        .logistics-trace-time {
            margin-bottom: 6px;
            color: #999999;
            font-size: 12px;
        }

        .logistics-trace-content {
            color: #333333;
            font-size: 14px;
            line-height: 1.6;
        }

        .modal-box-btn {
            justify-content: center;
            margin-top: 24px;

            .btn-r {
                margin-left: 0;
                text-align: center;
            }
        }
    }

    @media (max-width: 767px) {
        .pages {
            overflow-x: hidden;
            width: 100%;
            background: #f5f6f8;
            padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
        }

        .page-header {
            padding-top: env(safe-area-inset-top, 0px);
        }

        .page-header-placeholder {
            height: calc(56px + env(safe-area-inset-top, 0px));
        }

        .pc-float {
            display: none;
        }

        .box {
            padding: 0 12px 24px;
            box-sizing: border-box;
        }

        .boxBreadcrumb {
            padding: 10px 0 12px;
            overflow-x: auto;
            white-space: nowrap;
            font-size: 12px;
        }

        .boxDetail.is-h5 {
            padding: 0;
            background: transparent;
            box-shadow: none;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .h5-status-card {
            background: #fff;
            border-radius: 8px;
            padding: 16px 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
        }

        .h5-status-title {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            margin-bottom: 6px;
        }

        .h5-status-desc {
            font-size: 13px;
            color: #999;
            line-height: 1.5;
        }

        .h5-section-title {
            font-size: 15px;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;
        }

        .boxDetail .boxDetail-message {
            background: #fff;
            border-radius: 8px;
            padding: 16px 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

            &.virtual-goods-message {
                padding-bottom: 24px;
            }

            .message-btn {
                width: calc(50% - 6px);
                max-width: none;
                height: 40px;
                line-height: 40px;
            }

            .message-btn2 {
                margin-right: 0;
                margin-bottom: 0;
            }

            .align-center {
                flex-wrap: wrap;
                justify-content: center;
                gap: 10px;
                width: 100%;
            }
        }

        .pc-message {
            display: none;
        }

        .h5-goods-list {
            display: block;
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
        }

        .h5-goods-card {
            padding: 12px 0;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }

            &:first-of-type {
                padding-top: 0;
            }
        }

        .boxDetail .commodity img {
            width: 80px;
            height: 80px;
            flex-shrink: 0;
            object-fit: cover;
        }

        .boxDetail .commodity .commodity-r {
            margin-left: 12px;
            min-width: 0;
            flex: 1;
            justify-content: flex-start;
            gap: 6px;
        }

        .h5-goods-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 13px;
            color: #666;
            margin-top: 8px;
            padding: 0 2px;
        }

        .h5-goods-row-pay {
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px dashed #eee;
            font-size: 14px;
            color: #333;
        }

        .h5-goods-pay {
            color: #85674B;
            font-size: 16px;
            font-weight: bold;
        }

        .sum.h5-sum-card {
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            margin-top: 0;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
        }

        .sum .sum-box .text-20 {
            font-size: 18px !important;
        }

        .logistics {
            margin-top: 0;
            padding: 12px;
            background: #fff;
            border-radius: 8px;
            border: none;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

            .logistics-order .order-tit {
                font-size: 15px;
                margin-bottom: 12px;
            }

            .logistics-order .order-txt {
                display: flex;
                flex-direction: column;
                gap: 4px;
                margin-bottom: 12px;
                padding-bottom: 12px;
                border-bottom: 1px solid #f5f5f5;

                .txt-left {
                    padding-right: 0;
                    font-size: 12px;
                }

                span:last-child {
                    color: #333;
                    line-height: 1.5;
                    word-break: break-all;
                }
            }

            .logistics-order .order-txt:last-child {
                border-bottom: none;
                margin-bottom: 0;
                padding-bottom: 0;
            }
        }

        .order-step-wrap {
            margin-top: 0 !important;
            background: #fff;
            border-radius: 8px;
            padding: 12px 8px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
            overflow-x: auto;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        .boxDetail.is-h5 /deep/ .order-step-wrap .step {
            min-width: fit-content;
        }

        .boxDetail.is-h5 /deep/ .order-step-wrap .step .step-list {
            .list-box {
                font-size: 12px;
            }
        }

        .h5-action-bar {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 100;
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px 16px calc(10px + env(safe-area-inset-bottom, 0px));
            background: #fff;
            box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
            box-sizing: border-box;

            .message-btn {
                flex: 1;
                height: 44px;
                line-height: 44px;
                border-radius: 8px;
                font-size: 15px;
                text-align: center;
                cursor: pointer;
                box-sizing: border-box;
                transition: transform 0.15s ease, opacity 0.15s ease;
            }

            .message-btn:active {
                transform: scale(0.98);
                opacity: 0.88;
            }

            .message-btn1 {
                background: #000;
                color: #fff;
            }

            .message-btn2 {
                border: 1px solid #ccc;
                background: #fff;
                color: #333;
            }

            .h5-countdown {
                flex: 1;
                min-width: 0;
                padding: 8px 12px;
                background: #f8f8f8;
                border-radius: 8px;
                border-left: 3px solid #85674B;
                box-sizing: border-box;
            }

            .h5-countdown-label {
                font-size: 12px;
                color: #999;
                line-height: 1.4;
                margin-bottom: 4px;
            }

            .h5-countdown-time {
                line-height: 1.2;

                /deep/ .el-statistic {
                    width: auto;
                    line-height: 1.2;
                }

                /deep/ .el-statistic .con {
                    justify-content: flex-start;
                    padding: 0;
                }

                /deep/ .el-statistic .con .number {
                    font-size: 16px !important;
                    font-weight: 600;
                    color: #85674B !important;
                    letter-spacing: 0.5px;
                }
            }

            .h5-countdown+.message-btn {
                flex: 0 0 112px;
            }
        }

        .modal .modal-box {
            width: calc(100vw - 32px);
            max-width: 100%;
            padding: 24px 16px;
            box-sizing: border-box;

            .modal-box-txt {
                margin: 16px 0 24px;
                line-height: 1.6;
            }

            .modal-box-btn {
                width: 100%;
                justify-content: space-between;
                gap: 12px;

                div {
                    width: calc(50% - 6px);
                    margin: 0;
                }
            }
        }
    }

    .detail-pop-enter-active,
    .detail-pop-leave-active {
        transition: opacity 0.25s ease;
    }

    .detail-pop-enter-active .modal-box,
    .detail-pop-leave-active .modal-box {
        transition: transform 0.25s ease;
    }

    .detail-pop-enter,
    .detail-pop-leave-to {
        opacity: 0;
    }

    .detail-pop-enter .modal-box,
    .detail-pop-leave-to .modal-box {
        transform: translateY(16px) scale(0.96);
    }
</style>



// WEBPACK FOOTER //
// src/view/order/OrderDetail.vue